<template>
    <h1
        v-if="type == 'h1'"
        class="font-bold sm:text-2xl text-xl"
        :class="{
            ['md:text-' + size] : size,
            ['uppercase']: uppercase,
        }"
    >

        <span>{{__( label )}}</span>
        <p v-if="description" class="text-sm font-normal text-gray-600" v-html="description"></p>
    </h1>
    <h2
        v-else
    class="border-b-2 border-red-700 pb-4 mb-4 font-bold flex md:flex-row flex-col items-center"
        :class="{
            ['text-' + size] : size,
        }"
    >
        <IconLink
            v-if="backLink"
            :href="backLink"
            icon="arrow-left"
        >
        <template #addon>
            <span class="text-sm mr-2">{{__('Back')}}</span>
        </template>
        </IconLink>
        <div class="flex flex-wrap">
            <span class="mx-0.5">{{__( label )}}</span>
            <span class="mx-0.5" v-html="description"></span>
        </div>
    </h2>
</template>

<script>
import IconLink from 'UI/IconLink';
export default {
    props: {
        label: {
            type: String,
            default: 'No label :C'
        },
        type: {
            type: String,
            default: null,
        },
        description: {
            type: String,
            default: null
        },
        size: {
            type: String,
            default: 'xl'
        },
        color: {
            type: String,
            default: 'red'
        },
        backLink: {
            type: String,
        },
        uppercase: {
            type: Boolean,
            default: true,
        }
    },
    components: {IconLink}
}
</script>

<style lang="postcss" scoped>

h1 {
    @apply sm:w-full w-3/4 mx-auto;
}
h1 span {
    @apply relative;
}
h1 span:after, h1 span:before {
    content: '';
    @apply sm:w-10 w-6 h-1 bg-red-700 absolute transform top-1/2 -translate-y-1/2;
}
h1 span:after {
    @apply left-full ml-2;
}
h1 span::before {
    @apply right-full mr-2;
}

</style>
